(function () {
  'use strict';

  // Preserve unrounded preset results until final display rounding; see docs/s4-math/README.md.
  var DATA = {
    C: {
      net: 215.59492,
      gross: 864,
      owner: 432,
      energy: 28.40508,
      tires: 43.20,
      maint: 64.80,
      cleaning: 80,
      take: 0.50,
      assumptions: {
        hours: '10',
        util: '30%',
        mi: '12',
        rate: '$0.80',
        take: '50%',
        energy: 'TX res 15.94¢/kWh',
        cleaning: '$80'
      }
    },
    B: {
      net: 1197.697184,
      gross: 2217.60,
      owner: 1552.32,
      energy: 53.022816,
      tires: 80.64,
      maint: 120.96,
      cleaning: 100,
      take: 0.30,
      assumptions: {
        hours: '12',
        util: '40%',
        mi: '14',
        rate: '$1.10',
        take: '30%',
        energy: 'TX res 15.94¢/kWh',
        cleaning: '$100'
      }
    },
    O: {
      net: 2042.27773,
      gross: 3037.50,
      owner: 2430,
      energy: 34.72227,
      tires: 97.20,
      maint: 145.80,
      cleaning: 110,
      take: 0.20,
      assumptions: {
        hours: '12',
        util: '45%',
        mi: '15',
        rate: '$1.25',
        take: '20%',
        energy: 'TX com 8.66¢/kWh',
        cleaning: '$110'
      }
    }
  };

  var CAP_PER = 30000;
  var reduceMotion = false;

  function prefersReduced() {
    try {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function roundTasteful(n) {
    return Math.round(n);
  }

  function formatInt(n) {
    return roundTasteful(n).toLocaleString('en-US');
  }

  function formatMoney(n, withSign) {
    var v = roundTasteful(Math.abs(n));
    var s = '$' + v.toLocaleString('en-US');
    if (withSign === 'neg') return '−' + s;
    return s;
  }

  function setSeg(root, attr, value) {
    var btns = root.querySelectorAll('[' + attr + ']');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var on = btn.getAttribute(attr) === String(value);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  function animateNumber(el, from, to, duration, formatter) {
    if (reduceMotion || duration <= 0) {
      el.textContent = formatter(to);
      return;
    }
    var start = null;
    function frame(ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      var cur = from + (to - from) * eased;
      el.textContent = formatter(cur);
      if (t < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function init(root) {
    reduceMotion = prefersReduced();
    var state = { fleet: 1, scenario: 'B' };
    var monthlyEl = root.querySelector('[data-rtp-s4-monthly]');
    var annualEl = root.querySelector('[data-rtp-s4-annual]');
    var capitalEl = root.querySelector('[data-rtp-s4-capital]');
    var scaleEl = root.querySelector('[data-rtp-s4-flow-scale]');
    var fleetRoot = root.querySelector('[data-rtp-s4-fleet]');
    var scenarioRoot = root.querySelector('[data-rtp-s4-scenario]');
    var lastMonthly = DATA.B.net;

    function flowEl(key) {
      return root.querySelector('[data-flow="' + key + '"]');
    }
    function assumpEl(key) {
      return root.querySelector('[data-assump="' + key + '"]');
    }

    function render(animate) {
      var sc = DATA[state.scenario];
      var f = state.fleet;
      var monthly = sc.net * f;
      var annual = monthly * 12;
      var capital = CAP_PER * f;

      if (animate) {
        animateNumber(monthlyEl, lastMonthly, monthly, 420, formatInt);
      } else {
        monthlyEl.textContent = formatInt(monthly);
      }
      lastMonthly = monthly;

      annualEl.textContent = formatMoney(annual);
      capitalEl.textContent = formatMoney(capital);
      if (scaleEl) {
        scaleEl.textContent = f === 1 ? '(×1 vehicle)' : '(×' + f + ' vehicles)';
      }

      var networkRemoved = (sc.gross - sc.owner) * f;
      flowEl('gross').textContent = formatMoney(sc.gross * f);
      flowEl('network').textContent = formatMoney(networkRemoved, 'neg');
      flowEl('take-label').textContent = '(' + Math.round(sc.take * 100) + '% take)';
      flowEl('owner').textContent = formatMoney(sc.owner * f);
      flowEl('energy').textContent = formatMoney(sc.energy * f, 'neg');
      flowEl('tires-maint').textContent = formatMoney((sc.tires + sc.maint) * f, 'neg');
      flowEl('cleaning').textContent = formatMoney(sc.cleaning * f, 'neg');
      flowEl('net').textContent = formatMoney(monthly);

      var a = sc.assumptions;
      assumpEl('hours').textContent = a.hours;
      assumpEl('util').textContent = a.util;
      assumpEl('mi').textContent = a.mi;
      assumpEl('rate').textContent = a.rate;
      assumpEl('take').textContent = a.take;
      assumpEl('energy').textContent = a.energy;
      assumpEl('cleaning').textContent = a.cleaning;
    }

    function onFleet(v) {
      state.fleet = parseInt(v, 10);
      setSeg(fleetRoot, 'data-fleet', state.fleet);
      render(true);
    }
    function onScenario(v) {
      state.scenario = v;
      setSeg(scenarioRoot, 'data-scenario', state.scenario);
      render(true);
    }

    fleetRoot.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-fleet]');
      if (!btn || !fleetRoot.contains(btn)) return;
      onFleet(btn.getAttribute('data-fleet'));
    });
    scenarioRoot.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-scenario]');
      if (!btn || !scenarioRoot.contains(btn)) return;
      onScenario(btn.getAttribute('data-scenario'));
    });

    function keyNav(container, attr, values, current, setter) {
      container.addEventListener('keydown', function (e) {
        var idx = values.indexOf(String(current()));
        if (idx < 0) return;
        var next = idx;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (idx + 1) % values.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (idx - 1 + values.length) % values.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = values.length - 1;
        else return;
        e.preventDefault();
        setter(values[next]);
        var focusBtn = container.querySelector('[' + attr + '="' + values[next] + '"]');
        if (focusBtn) focusBtn.focus();
      });
    }

    keyNav(fleetRoot, 'data-fleet', ['1', '5', '10'], function () { return state.fleet; }, onFleet);
    keyNav(scenarioRoot, 'data-scenario', ['C', 'B', 'O'], function () { return state.scenario; }, onScenario);

    var details = root.querySelector('[data-rtp-s4-assumptions]');
    var label = root.querySelector('[data-rtp-s4-assumptions-label]');
    if (details && label) {
      details.addEventListener('toggle', function () {
        label.textContent = details.open
          ? 'HIDE SCENARIO ASSUMPTIONS ↑'
          : 'VIEW SCENARIO ASSUMPTIONS ↓';
      });
    }

    render(false);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-rtp-s4]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
